<template>
  <v-container grid-list-xs style="max-width: 1070px" class="mt-4">
    <v-carousel cycle show-arrows-on-hover height="600" >
      <v-carousel-item v-for="(item,i) in itemsCarrusel" :key="i" :src="item" reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>
    </v-carousel>
    <v-row align="center" justify="center" class="mt-5">
      <viewer :images="itemsOtros" class="text-center" :options="options">
        <img :src="src"  v-for="src in itemsOtros"  :key="src" width="332" height="332" class="ma-2">
       </viewer>
    </v-row>
  </v-container> 
</template>

<script>
  import axios from 'axios';
  import { documentosBaseURL }  from '@/general';

  export default {
    metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Galeria - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
    data () {
      return {
        itemsCarrusel: [],
        itemsOtros: [],
        options: {
          "button": false, 
          "navbar": false, 
          "title": false, 
          "toolbar": false, 
          "tooltip": false, 
          "movable": false, 
          "zoomable": false, 
          "rotatable": false, 
          "scalable": false, 
          // "transition": false, 
          "fullscreen": false, 
          "keyboard": false, 
        },
      }
    },

    created(){
      this.getGaleria()
    },

    methods:{
      async getGaleria(){
        let response = await this.galeria()
        if (response.state == '1') {
          delete response['state'];
          for (let index = 0; index < 10; index++) {
            const elementC = documentosBaseURL + response[index].nombre;
            this.itemsCarrusel.push(elementC)
          }
          for (let index2 = 10; index2 < Object.keys(response).length; index2++) {
            const elementO = documentosBaseURL + response[index2].nombre;
            this.itemsOtros.push(elementO)
          }
        }
      },

      galeria(){
        return new Promise((resolve, reject) => {
          axios.post('getGaleria.php')
          .then((response) => {
              resolve(response.data);
          }).catch((error) => reject(error));
        });
      },
    }
  }
</script>